import { useContext, useEffect } from "react";
import { Spinner, Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import Select from 'react-select';

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import PaginationList from "./../../../utils/PaginationList/PaginationList";
import OnTypeSearch from "../../../utils/OnTypeSearch/OnTypeSearch";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { adminAdminContext } from "../../../context/Admin/AdminAdminContext/AdminAdminContext";
import {
  adminPermissionItems,
  convertAdminPermissionToText,
} from "../../../utils";
import TooltipTitle from "../../../utils/TooltipTitle/TooltipTitle";

const AdminAdmin = () => {
  const permission = useSelector((state) => state.permission);

  const {
    admins,
    users,
    setUsers,
    userSearch,
    setUserSearch,
    id,
    first_name,
    setFirst_name,
    last_name,
    setLast_name,
    mobile,
    setMobile,
    password,
    setPassword,
    search_permission,
    setSearch_permission,
    permission_level,
    setPermission_level,
    totalCount,
    pageNumber,
    setPageNumber,
    limit,
    setLimit,
    isShowModal,
    isUserLoading,
    handleCreateAdmin,
    handleEditAdmin,
    handleShowModal,
    handleCloseModal,
    handleGetUsers,
    handleGetAdmins,
    handleDeleteAdmin,
    handleRevokeTokenAdmin,
    handleLoginAdmin,
    cities,
    managedCities,
    setManagedCities
  } = useContext(adminAdminContext);

  const onTypeUserSearch = OnTypeSearch(setUserSearch);

  useEffect(() => {
    if (isShowModal && userSearch) handleGetUsers();
    else setUsers([]);
  }, [userSearch]);

  useEffect(() => {
    handleGetAdmins();
  }, [pageNumber, limit, search_permission]);

  return (
    <>
      <SiteTitle title="مدیران" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "مدیران", type: "a" },
        ]}
        title="لیست مدیران"
      />

      <CardLayout>
        {permission.users_create && (
          <div className="mb-2">
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}

        <div className="mb-2">
          <select
            className="form-control"
            id="search_permission"
            name="search_permission"
            value={search_permission}
            onChange={(e) => setSearch_permission(e.target.value)}
          >
            <option value="">سطح دسترسی: همه</option>

            {adminPermissionItems?.map((_item) => (
              <option key={_item} value={_item}>
                {convertAdminPermissionToText(_item)}
              </option>
            ))}
          </select>
        </div>
        {isEmpty(admins) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>شناسه</th>
                  <th>نام</th>
                  <th>نام خانوادگی</th>
                  <th>موبایل</th>
                  <th>سطح دسترسی</th>
                  <th className="text-center">
                    تعداد کل :{" "}
                    <span className="badge badge-primary font-weight-bold p-1">
                      {totalCount}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {admins.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{_item.id}</td>
                    <td>{_item.first_name}</td>
                    <td>{_item.last_name}</td>
                    <td>{_item.mobile}</td>
                    <td>
                      {convertAdminPermissionToText(_item.permission_level)}
                    </td>
                    <td className="mw-25">
                      <button
                        onClick={() => handleLoginAdmin(_item)}
                        className="btn btn-info mr-2"
                      >
                        ورود به حساب کاربری
                      </button>
                      {permission.users_update && (
                        <button
                          onClick={() => handleShowModal(_item)}
                          className="btn btn-primary mr-2"
                        >
                          جزئیات و ویرایش
                        </button>
                      )}
                      <button
                        onClick={() =>
                          areYouSureMessage(
                            () => handleRevokeTokenAdmin(_item.id),
                            `آیا از بازنشانی نشست ${_item.first_name} ${_item.last_name} اطمینان دارید؟`
                          )
                        }
                        className="btn btn-warning mr-2"
                      >
                        بازنشانی نشست
                      </button>
                      <i
                        onClick={() =>
                          areYouSureMessage(
                            () => handleDeleteAdmin(_item.id),
                            `آیا از حذف ${_item.first_name} ${_item.last_name} اطمینان دارید؟`
                          )
                        }
                        className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} مدیر`}
        show={isShowModal}
        onHide={handleCloseModal}
        size="md"
      >
        {!id && (
          <>
            <form
              className="input-group position-relative mb-2"
              onSubmit={(e) => {
                handleGetUsers(e);
              }}
            >
              <input
                {...onTypeUserSearch}
                id="userSearch"
                name="userSearch"
                placeholder="جستجو کاربر"
                className="form-control"
                autocomplete="off"
              />
              <div className="input-group-append">
                <button className="btn btn-primary" type="submit">
                  <i className="fa fa-search"></i>
                </button>
              </div>
              <div className="input-group-append">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setTimeout(() => setUsers([]), 300);
                    setUserSearch("");
                  }}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>
            </form>
            {isUserLoading ? (
              <div className="text-center mt-2">
                <Spinner animation="grow" variant="success" />
              </div>
            ) : isEmpty(users) ? null : (
              <div className="position-relative">
                <div className="searchListAutoComplete">
                  {users.map((_user) => (
                    <div className="d-flex align-items-center">
                      <div
                        className="card border m-0 searchAutoCompleteCard col font-weight-bold"
                        onClick={() => {
                          setFirst_name(_user?.first_name);
                          setLast_name(_user?.last_name);
                          setMobile(_user?.mobile);
                          setUsers([]);
                        }}
                      >
                        <div className="p-2 d-flex justify-content-between">
                          <div>
                            {_user?.first_name} {_user?.last_name}
                          </div>
                          <div className="bg-white">
                            <TooltipTitle title="شماره موبایل">
                              <span>{_user?.mobile}</span>
                            </TooltipTitle>{" "}
                            -{" "}
                            <TooltipTitle title="شناسه">
                              <span>{_user?.pk}</span>
                            </TooltipTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
        <form
          onSubmit={id ? handleEditAdmin : handleCreateAdmin}
          autoComplete="off"
        >
          <div className="row">
            <div className="col-12 mb-2">
              <label htmlFor="first_name">نام</label>
              <input
                type="text"
                id="first_name"
                name="first_name"
                className="form-control"
                value={first_name}
                onChange={(e) => setFirst_name(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="last_name">نام خانوادگی</label>
              <input
                type="text"
                id="last_name"
                name="last_name"
                className="form-control"
                value={last_name}
                onChange={(e) => setLast_name(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="mobile">موبایل</label>
              <input
                type="number"
                id="mobile"
                name="mobile"
                className="form-control"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="password">کلمه عبور</label>
              <input
                type="text"
                id="password"
                name="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label>سطح دسترسی</label>
              <select
                className="form-control"
                onChange={(e) => setPermission_level(e.target.value)}
                value={permission_level}
              >
                <option value="" disabled hidden>
                  سطح دسترسی مدیر را انتخاب کنید
                </option>
                {adminPermissionItems?.map((_item) => (
                  <option key={_item} value={_item}>
                    {convertAdminPermissionToText(_item)}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-12 mb-2" dir="rtl">
            <label htmlFor="adminCities">شهر های تحت مدیریت</label>
            <Select
              id="adminCities"
              name="adminCities"
              options={cities}
              value={managedCities}
              onChange={setManagedCities}
              isMulti
              isRtl={true}
              placeholder="شهر ها را انتخاب کنید"
              noOptionsMessage={() => "شهری یافت نشد"}
              className="basic-multi-select font-sans text-sm"
              classNamePrefix="select"
            />
          </div>
          <button className="btn btn-primary btn-block" type="submit">
            <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
          </button>
        </form>
      </CustomModal>
      {/* End Create Modal */}
    </>
  );
};

export default AdminAdmin;
